/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useLazyGetAllPillsQuery } from "../../../../services/gallusTools";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface DeleteTileModalProps {
  selectedTileID: number;
  modalIsOpen: boolean;
  toggleModal: () => void;
  deleteTileFunction: () => void;
}

export const DeleteTileModal = (props: DeleteTileModalProps) => {
  const [TileTitle, setTileTitle] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [getTilesQuery, getTilesQueryResult] = useLazyGetAllPillsQuery(); //TODO: Change this to a id get query

  useEffect(() => {
    if (
      getTilesQueryResult.isSuccess &&
      getTilesQueryResult.status === "fulfilled"
    ) {
      const currentTileData = getTilesQueryResult.data.find(
        (Tile) => Tile.id === props.selectedTileID,
      );

      if (currentTileData) {
        setTileTitle(currentTileData.title);
        setLoading(false);
      }
    }
  }, [getTilesQueryResult]);

  useEffect(() => {
    getTilesQuery();
  }, []);

  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Delete Tile</ModalHeader>
      <div>
        {loading && (
          <div className="loading-div">
            <FontAwesomeIcon
              icon={faSpinner}
              size="2x"
              spin={true}
              style={{ margin: "0 auto" }}
            />
          </div>
        )}
        {!loading && (
          <div>
            <ModalBody>
              Do you want to delete the tile named {TileTitle}?
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => {
                  props.toggleModal();
                  props.deleteTileFunction();
                }}
              >
                Yes
              </Button>
              <Button color="secondary" onClick={() => props.toggleModal()}>
                Cancel
              </Button>
            </ModalFooter>
          </div>
        )}
      </div>
    </Modal>
  );
};
